import React, { useState, useEffect, useContext } from "react";
import { BrowserRouter as Router, Link, useParams } from "react-router-dom";
import { api } from "../../utils/Api";
import RejectAlert from "../../components/Alert/RejectAlert";
import bootstrap from "../../assets/libraries/bootstrap/js/bootstrap";

const new_data = [
  {
    company: "Twitter Inc",
    tasks: [
      {
        name: "active",
        qty: "2",
      },
      {
        name: "new",
        qty: "2",
      },
      {
        name: "completed",
        qty: "2",
      },
      {
        name: "rejected",
        qty: "2",
      },
    ],
  },
  {
    company: "Square Inc",
    tasks: [
      {
        name: "active",
        qty: "2",
      },
      {
        name: "new",
        qty: "2",
      },
      {
        name: "completed",
        qty: "2",
      },
      {
        name: "rejected",
        qty: "2",
      },
    ],
  },
  {
    company: "SK Inc",
    tasks: [
      {
        name: "active",
        qty: "2",
      },
      {
        name: "new",
        qty: "2",
      },
    ],
  },

  {
    company: "Huskky Photography",
    tasks: [
      {
        name: "active",
        qty: "3",
      },
      {
        name: "new",
        qty: "4",
      },
      {
        name: "completed",
        qty: "6",
      },
      {
        name: "rejected",
        qty: "2",
      },
    ],
  },
];

const active_data = [
  {
    company: "Twitter Inc",
    id: "1",
    tasks: [
      {
        name: "active",
        qty: "2",
      },
      {
        name: "new",
        qty: "2",
      },
      {
        name: "completed",
        qty: "2",
      },
      {
        name: "rejected",
        qty: "2",
      },
    ],
  },
  {
    company: "Square Inc",
    id: "2",
    tasks: [
      {
        name: "active",
        qty: "2",
      },
      {
        name: "new",
        qty: "2",
      },
      {
        name: "completed",
        qty: "2",
      },
      {
        name: "rejected",
        qty: "2",
      },
    ],
  },
  {
    company: "SK Inc",
    id: "3",
    tasks: [
      {
        name: "active",
        qty: "2",
      },
      {
        name: "new",
        qty: "2",
      },
    ],
  },

  {
    company: "Huskky Photography",

    id: "4",
    tasks: [
      {
        name: "active",
        qty: "3",
      },
      {
        name: "new",
        qty: "4",
      },
      {
        name: "completed",
        qty: "6",
      },
      {
        name: "rejected",
        qty: "2",
      },
    ],
  },
];

export default function CompanyJoinInvitition(props: any) {
  const [invitition, setInvitition] = useState([]);
  const [open, setOpen] = useState();
  const [id_values, SetIdValues] = useState(useParams());
  const [history, SetHistory] = useState(Boolean);
  const [next_page, SetNextPage] = useState(false);
  const [page_no, SetPageNo] = useState(1);
  const [historyVal, SetHistoryVal] = useState([]);

  const [reject_modal, SetRejectModal] = useState({
    is_open: false,
    title: "",
    record: {},
    index: "",
  });

  async function get_invite() {
    //     // }

    // console.log(profileDetails);

    let pass_data: any = {
      get: {
        page: page_no,
      },
    };
    if (id_values.work_id != "all") {
      pass_data.get.id = id_values.join_id;
    }
    if (history) {
      pass_data.get.history = false;
    }

    console.log("pass_data :", pass_data);

    let response = await api("/company/invitations", pass_data);
    console.log("job_invitations response :", response.response.data);
    setInvitition(response.response.data);
    setOpen(response.response.opened_data);

    if (response.response.next_page) {
      SetPageNo(page_no + 1);
      SetNextPage(true);
    } else {
      SetNextPage(false);
    }
  }

  async function get_history() {
    SetHistoryVal([]);

    let history_val = historyVal;
    console.log(historyVal);
    let pass_data: any = {
      get: {
        page: page_no,
      },
    };
    if (id_values.work_id != "all") {
      pass_data.get.id = id_values.join_id;
    }
    if (history) {
      pass_data.get.history = true;
    }

    console.log("pass_data :", pass_data);

    let response = await api("/company/invitations", pass_data);

    console.log("job_invitations response :", response.response.data);
    // setInvitition(response.response.data);
    SetHistoryVal(response.response.data);
    console.log(historyVal);

    setOpen(response.response.opened_data);

    for (let i = 0; i < response.response.data.length; i++) {
      history_val.push(response.response.data[i]);
    }

    SetHistoryVal(history_val);
    console.log(historyVal);

    if (response.response.next_page) {
      SetPageNo(page_no + 1);
      SetNextPage(true);
    } else {
      SetNextPage(false);
    }
  }

  async function accept_invite(item: any, index: any) {
    let pass_data = {
      post: {
        invitation_id: item.id,
      },
    };
    let data = await api("/company/accept_invitation", pass_data);
    console.log("delete_service response :", data);
    if (data.status_code == 200) {
      // let old_services = service_data;
      // old_services.splice(index, 1);
      // SetServiceData([...old_services]);
      let pass_data: any = {
        get: {
          page: 1,
        },
      };
      let response = await api("/company/invitations", pass_data);

      console.log("job_invitations response :", response.response.data);
      setInvitition(response.response.data);
    }
  }

  async function reject_invite(record: any, index: any) {
    let pass_data = {
      post: {
        invitation_id: record,
      },
    };
    let data = await api("/company/reject_invitation", pass_data);
    console.log("delete_service response :", data);
    if (data.status_code == 200) {
      let pass_data: any = {
        get: {
          page: 1,
        },
      };
      // let old_services = service_data;
      // old_services.splice(index, 1);
      // SetServiceData([...old_services]);
      let response = await api("/company/invitations", pass_data);

      console.log("job_invitations response :", response.response.data);
      setInvitition(response.response.data);
    }
  }

  useEffect(() => {
    console.log("Activity On mount :", props);
    get_invite();

    if (history) {
      get_history();
    }
  }, [history]);

  return (
    <>
      <div className="bg-white mb-3 pt-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h5 className="mb-3">Company Invititions</h5>
              <div className="col-lg-12">
                <nav className="pt-1 sticky-tabs">
                  <div className="nav nav-tabs " id="nav-tab" role="tablist">
                    <button
                      className="nav-link active"
                      id="active-users-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#active-users"
                      type="button"
                      role="tab"
                      aria-controls="active-users"
                      aria-selected="true"
                      onClick={() => {
                        SetHistory(false);
                        SetPageNo(1);
                        setInvitition([]);
                      }}
                    >
                      Invitition
                    </button>
                    <button
                      className="nav-link"
                      id="deleted-users-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#history-tasks"
                      type="button"
                      role="tab"
                      aria-controls="deleted-users"
                      aria-selected="false"
                      onClick={() => {
                        SetHistory(true);
                        SetPageNo(1);
                        SetHistoryVal([]);
                      }}
                    >
                      History
                    </button>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {invitition || open ? (
        <div className=" basic-list">
          <div className="tab-content" id="nav-tabContent">
            <div
              className="tab-pane fade show active"
              id="active-users"
              role="tabpanel"
              aria-labelledby="active-users-tab"
            >
              <div className="container">
                <div className="row">
            
                      {open && (
                
                      <div className=" mb-2 br-3 p-3 open-task col-lg-8 mx-auto">
              
                            <div className="d-lg-flex">
                              <div className="fs-14">
                                {open.name}
                              </div>
                              <div className="ms-auto">
                                <div className="text-muted fs-14">
                                  {open.created_at}
                                </div>
                              </div>
                            </div>

                            <div>{open.message}</div>
                            <div className="d-flex">
                              <div className="ms-auto">
                                <div className="col card-text">
                                  {open.status == "Accepted" && (
                                    <span className="badge bg-primary">
                                      Accepted
                                    </span>
                                  )}

                                  {open.status == "Rejected" && (
                                    <span className="badge bg-danger">
                                      Rejected
                                    </span>
                                  )}

                                  {open.status == "Deleted" && (
                                    <span className="badge bg-danger">
                                      Deleted
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                            
                            {/* ((((((((((())))))))))) */}
                            {open.status == null && (
                              <div>
                                <button
                                  type="button"
                                  className="btn btn-primary m-2 btn-sm px-3"
                                  onClick={() => {
                                    accept_invite(open, index);
                                  }}
                                >
                                  Accept
                                </button>

                                <button
                                  type="button"
                                  className="btn btn-danger m-2 btn-sm px-3"
                                  data-bs-toggle="modal"
                                  data-bs-target="#exampleModal"
                                  onClick={() => {
                                    // delete_service(data, s_index);
                                    SetRejectModal((prevValue) => {
                                      prevValue.is_open = true;
                                      prevValue.title = "invitation";
                                      prevValue.record = open.id;
                                      prevValue.index = index;
                                      return { ...prevValue };
                                    });
                                  }}
                                >
                                  Reject
                                </button>
                              </div>
                            )}
                        
                        
                          </div>
                    
                      )}
                      {invitition.map((item, index) => (
                          <div className="box-2 mb-2 br-3 p-3 col-lg-8 mx-auto">
                         
                            <div className="d-lg-flex">
                              <div>
                                <div className="fs-14">{item.name}</div>
                              </div>
                              <div className="ms-auto">
                                <div className="text-muted fs-14">
                                  {item.created_at}
                                </div>
                              </div>
                            </div>

                            <div>{item.message}</div>
                            <div className="d-flex">
                              <div className="ms-auto">
                                <div className="col card-text">
                                  {item.status == "Accepted" && (
                                    <span className="badge bg-primary">
                                      Accepted
                                    </span>
                                  )}

                                  {item.status == "Rejected" && (
                                    <span className="badge bg-danger">
                                      Rejected
                                    </span>
                                  )}

                                  {item.status == "Deleted" && (
                                    <span className="badge bg-danger">
                                      Deleted
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                        
                            {/* ((((((((((())))))))))) */}
                            {item.status == null && (
                              <div className="mt-2">
                                <button
                                  type="button"
                                  className="btn btn-primary btn-sm px-3 me-2"
                                  onClick={() => {
                                    accept_invite(item, index);
                                  }}
                                >
                                  Accept
                                </button>

                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm px-3"
                                  data-bs-toggle="modal"
                                  data-bs-target="#exampleModal"
                                  onClick={() => {
                                    // delete_service(data, s_index);
                                    SetRejectModal((prevValue) => {
                                      prevValue.is_open = true;
                                      prevValue.title = "invitation";
                                      prevValue.record = item.id;
                                      prevValue.index = index;
                                      return { ...prevValue };
                                    });
                                  }}
                                >
                                  Reject
                                </button>
                              </div>
                            )}
                         
                       
                          </div>
                      ))}
                  
                </div>

                {next_page ? (
                  <div className="text-center mt-3 mb-3 ">
                    <button
                      type="button"
                      className="load btn btn-primary px-3"
                      onClick={() => {
                        get_invite();
                      }}
                    >
                      <b>Load More</b>
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="history-tasks"
              role="tabpanel"
              aria-labelledby="deleted-users-tab"
            >
              <div className="container">
              <div className="row">
                {historyVal?.map((item: any, index: any) => (
                        <div className="box-2 mb-2 br-3 p-3 col-lg-8 mx-auto">
                
                          <div className="d-lg-flex">
                            <div className="fs-14">{item.name}</div>
                            <div className="ms-auto"></div>
                            <div>
                              
                              <div className="text-muted fs-14">{item.created_at}</div>
                              
                            </div>
                          </div>
                          <div className="fs-13">{item.message}</div>
    
                          <div className="d-flex">
                            {/*________________________________Time Histrory___________________________________________*/}
                            
                            <div className="ms-auto">
                              <div className="col card-text">
                                {item.status == "Accepted" && (
                                  <span className="badge bg-primary">Accepted</span>
                                )}
    
                                {item.status == "Rejected" && (
                                  <span className="badge bg-danger">Rejected</span>
                                )}
    
                                {item.status == "Deleted" && (
                                  <span className="badge bg-danger">Deleted</span>
                                )}
                              </div>
                            </div>
    
                            {item.status == null && (
                              <>
                                <button
                                  type="button"
                                  className="btn btn-primary m-2"
                                  onClick={() => {
                                    accept_invite(item, index);
                                  }}
                                >
                                  Accept
                                </button>
    
                                <button
                                  type="button"
                                  className="btn btn-danger m-2"
                                  data-bs-toggle="modal"
                                  data-bs-target="#exampleModal"
                                  onClick={() => {
                                    // delete_service(data, s_index);
                                    SetRejectModal((prevValue) => {
                                      prevValue.is_open = true;
                                      prevValue.title = "invitation";
                                      prevValue.record = item.id;
                                      prevValue.index = index;
                                      return { ...prevValue };
                                    });
                                  }}
                                >
                                  Reject
                                </button>
                              </>
                            )}
                          </div>
                        </div>
              
                ))}
              </div>
              </div>

              {next_page ? (
                <div className="text-center mt-3 mb-3">
                  <button
                    type="button"
                    className="load btn btn-primary px-3 "
                    onClick={() => {
                      get_history();
                    }}
                  >
                    <b>Load More</b>
                  </button>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      ) : (
        <h5>No companies invitations</h5>
      )}

      <RejectAlert
        open={reject_modal.is_open}
        title={reject_modal.title}
        record={reject_modal.record}
        index={reject_modal.index}
        close={(data) => {
          SetRejectModal((prevValue) => {
            prevValue.is_open = false;
            return { ...prevValue };
          });

          if (data.action === "delete") {
            console.log("delete Service : ", data);
            reject_invite(data.value, data.index);
          }
        }}
      />
    </>
  );
}
